










































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { ServerResult } from "@/core/http/server_result";
import { QueryBuilder } from "@/core/uql";
import { buildSemifinishedProductComboboxItems } from "./semifinishedProductComboboxItems";

@Component
export default class SemifinishedProductCombobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>;
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop() excludeId!: any;
  @Prop({ type: String }) position!: string;
  @Prop({ type: String, default: "Выберите полуфабрикат" })
  placeholder!: string;

  localValue: any = null;
  selectedItemLabel: any = "";
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];
  searchText: string = "";

  public mounted() {
    this.selectedItemLabel = this.placeholder;
    this.loadData();
  }

  public loadData() {
    const QNAME = "SELECT_SEMIFINISHED_PRODUCT_COMBOBOX";
    console.debug("[SemifinishedProductCombobox.loadData] START");

    this.$db([
      this.$q(QNAME)
        .raw("documents.list")
        .action({
          columns: {
            id: "products.id",
            name: "products.name"
          },
          from: "s:products",
          from_as: "products",
          where: {
            // литерал в сравнении DocAPI передаётся константой {"$": value}
            $eq: ["products.is_semifinished", { $: true }]
          },
          page_size: 100000,
          order: [{ $asc: ["products.name"] }]
        })
    ])
      .then((result: ServerResult) => {
        const documents =
          (result.getOperation(QNAME).getContent() || {}).documents || [];
        this.items = buildSemifinishedProductComboboxItems(
          documents,
          this.excludeId
        );
        console.debug("[SemifinishedProductCombobox.loadData] SUCCESS", {
          documents: documents.length,
          items: this.items.length
        });

        this.onValueChange(this.value);
        this.updateDisplayList();
      })
      .catch((error: any) => {
        console.error("[SemifinishedProductCombobox.loadData] ERROR", { error });
      });
  }

  @Watch("value")
  onValueChange(newVal: any) {
    this.localValue = newVal;

    if (this.localValue) {
      const selectedItem = this.items.find(
        (item: any) => item.id == this.localValue
      );
      this.selectedItemLabel = selectedItem
        ? selectedItem.label
        : this.placeholder;
    } else {
      this.selectedItemLabel = this.placeholder;
    }
  }

  updateValue(value: any) {
    console.debug("[SemifinishedProductCombobox.updateValue]", { value });
    this.onValueChange(value);
    this.$emit("input", value);

    const selectedItem = this.items.find(
      (item: any) => item.id == this.localValue
    );
    this.$emit("input-object", selectedItem || null);
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + "px";
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width =
      width - 25 + "px";
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus();
    }
  }

  @Watch("searchText")
  updateDisplayList() {
    const needle = (this.searchText || "").toLowerCase();
    if (!needle) {
      this.$set(this, "itemsForDisplay", this.items || []);
      return;
    }

    this.$set(
      this,
      "itemsForDisplay",
      (this.items || []).filter((item: any) =>
        (item.label || "").toLowerCase().includes(needle)
      )
    );
  }
}
